/**
 * NotificationEditorController
 * @author Denis Sobolev
 */

import template from './delete-drawer/deleteNotification.html';

function NotificationEditorController(
  $scope,
  $translate,
  $log,
  notificationService,
  navigationService,
  timezoneService,
  LoggedInUser,
  $state,
  $stateParams,
  $timeout,
  $uibModal,
  _,
  toastWrapperService,
  analyticsService
) {
  $scope.clone = $stateParams.clone;

  $scope.triggerBlocks = {};

  $scope.user = LoggedInUser;

  $scope.displayTimezone = timezoneService.getTimezoneDisplay;

  const ownerType = $stateParams.groupId ? 'group' : 'user';
  const owernerID = $stateParams.groupId
    ? $stateParams.groupId
    : $scope.user.username;

  $scope.notification = notificationService.getNewNotification(
    ownerType,
    owernerID
  );

  if ($stateParams.notificationId) {
    notificationService.initialized.then(() => {
      notificationService.get($stateParams.notificationId).then(
        (notif) => {
          const notification = notif;
          _.forOwn(notification.trigger, (value, key) => {
            if (value === null) delete notification.trigger[key];
          });

          $scope.notification.trigger.pitch.pitchStatus = [];
          _.merge($scope.notification, notification);
          $scope.notification.original = notification;

          if ($scope.clone) {
            $scope.notification.id = null;
          }

          if (
            $scope.notification.target.type === 'slack' &&
            $scope.notification.target.username
          ) {
            $scope.notification.target.channel =
              $scope.notification.target.username;
          } else if ($scope.notification.target.type === 'teams') {
            $scope.notification.target.channel =
              $scope.notification.target.channelId;
          }

          navigationService.navigateProfile('profile.editnotification');
          $scope.ready = true;
        },
        (error) => {
          $log.error(error);
          navigationService.navigateProfile('profile.createnotification');
        }
      );
    });
  } else {
    navigationService.navigateProfile('profile.createnotification');
    $scope.ready = true;
  }

  if ($stateParams.notification) {
    $scope.triggerTypeSelected = true;
  }

  $scope.triggerTypes = notificationService.triggerTypes;

  $scope.markTriggerTypeSelected = () => {
    $scope.triggerTypeSelected = true;
  };

  $scope.$watchCollection('triggerBlocks', () => {
    $scope.anyTargetBlocksSelected = _.compact(
      _.values($scope.triggerBlocks)
    ).length;
  });

  $scope.closeAlert = (alert) => {
    _.remove($scope.alerts, alert);
  };

  $scope.submit = () => {
    $scope.submitted = true;
    $scope.notification_form.$setSubmitted();

    $timeout(() => {
      $scope.alerts = [];

      if (
        $scope.anyTargetBlocksSelected &&
        !$scope.notification_form.$invalid
      ) {
        $scope.requestRunning = true;

        const notificationData = angular.copy($scope.notification);

        if (notificationData.target.type === 'slack') {
          notificationData.target.integrationID =
            notificationData.target.slackIntegrationID;
        } else if (notificationData.target.type === 'teams') {
          notificationData.target.integrationID =
            notificationData.target.teamsIntegrationID;
        }

        _.forOwn(notificationData.trigger, (property, propertyName) => {
          if (!$scope.triggerBlocks[propertyName] && propertyName !== 'type') {
            delete notificationData.trigger[propertyName];
          }
        });

        _.forOwn(notificationData.target, (property, propertyName) => {
          if (
            !notificationService.isTargetFieldRequired(
              notificationData,
              propertyName
            )
          ) {
            delete notificationData.target[propertyName];
          }
        });

        if (notificationData.id) {
          notificationService.update(notificationData).then(
            () => {
              $scope.requestRunning = false;
              toastWrapperService.createToast(
                $translate.instant('NOTIFICATION_UPDATED_SUCCESSFULLY'),
                'success'
              );
              analyticsService.trackEvent(
                'Notification management',
                'Updated notification'
              );
              $scope.usernameError = false;
              $state.go('^.notifications', {}, { reload: true });
            },
            (response) => {
              $scope.requestRunning = false;
              if (
                response.data &&
                response.data.error &&
                response.data.error.startsWith(
                  'The following username was not found for your Slack'
                )
              ) {
                $scope.usernameError = true;
              } else {
                $log.error(
                  'NotificationEditorController notificationService.update() error',
                  response.data.error || response.data
                );
                toastWrapperService.createToast(
                  $translate.instant('NOTIFICATION_UPDATE_FAILED'),
                  'danger'
                );
              }
            }
          );
        } else {
          notificationService.create(notificationData).then(
            () => {
              $scope.requestRunning = false;
              toastWrapperService.createToast(
                $translate.instant('NOTIFICATION_CREATED_SUCCESSFULLY'),
                'success'
              );
              analyticsService.trackEvent(
                'Notification management',
                'Created notification'
              );
              $scope.usernameError = false;
              $state.go('^.notifications', {}, { reload: true });
            },
            (response) => {
              $scope.requestRunning = false;
              if (
                response.data &&
                response.data.error &&
                response.data.error.startsWith(
                  'The following username was not found for your Slack team'
                )
              ) {
                $scope.usernameError = true;
              } else {
                $log.error(
                  'NotificationEditorController notificationService.create() error',
                  response.data.error || response.data
                );
                toastWrapperService.createToast(
                  $translate.instant('ERROR_CREATING_NOTIFICATION'),
                  'danger'
                );
              }
            }
          );
        }
      } else {
        if (!$scope.anyTargetBlocksSelected) {
          $scope.alerts.push({
            type: 'danger',
            msg: $translate.instant('SELECT_ONE_FILTER')
          });
        }
        if ($scope.notification_form.$invalid) {
          $scope.alerts.push({
            type: 'danger',
            msg: $translate.instant('PLEASE_CHECK_INPUT_RESUBMIT')
          });
        }
      }
    }, 0);
  };

  $scope.triggerBlockSelected = (name, value) => {
    $scope.triggerBlocks[name] = value;
  };

  $scope.delete = (notification) => {
    $uibModal
      .open({
        template,
        controller: 'NotificationDeleteDrawerController',
        resolve: {
          notification() {
            return notification;
          }
        }
      })
      .result.then(() => {
        analyticsService.trackEvent(
          'Notification management',
          'Deleted notification'
        );
        $state.go('^.notifications', {}, { reload: true });
      });
  };
}

const arr = [
  '$scope',
  '$translate',
  '$log',
  'notificationService',
  'navigationService',
  'timezoneService',
  'LoggedInUser',
  '$state',
  '$stateParams',
  '$timeout',
  '$uibModal',
  '_',
  'toastWrapperService',
  'analyticsService',
  NotificationEditorController
];

export default function (ngModule) {
  ngModule.controller('NotificationEditorController', arr);
}
